import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, MessageCircle, Send, CheckCircle } from 'lucide-react';
import { contactInfo } from '../mock';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Footer = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      await axios.post(`${BACKEND_URL}/api/chat/newsletter/subscribe`, { email });
      setSubscribed(true);
      setEmail('');
    } catch {}
    setLoading(false);
  };

  return (
    <footer className="bg-[#05050A] border-t border-white/[0.04]" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-10">
          <div>
            <img
              src="https://customer-assets-39nsmqrw.emergentagent.net/job_209c8813-566e-47da-85c4-1d1fadce8833/artifacts/rzf7k7uf_starnight101.png"
              alt="Starnight Holdings"
              className="h-9 w-auto object-contain mb-4 opacity-80"
            />
            <p className="text-white/20 text-xs leading-relaxed max-w-xs">
              Building excellence across virtual worlds with professionalism and dedication.
            </p>
          </div>

          <div>
            <h3 className="text-[11px] text-white/30 font-medium uppercase tracking-[0.15em] mb-4">Quick Links</h3>
            <ul className="space-y-2.5">
              {[
                { label: 'About Us', path: '/#about' },
                { label: 'Our Groups', path: '/#groups' },
                { label: 'Meet the Team', path: '/team' },
                { label: 'Staff Portal', path: '/staff/login' },
              ].map((link, i) => (
                <li key={i}>
                  <Link to={link.path} className="text-white/20 hover:text-[#00E5FF] text-xs transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-[11px] text-white/30 font-medium uppercase tracking-[0.15em] mb-4">Contact Us</h3>
            <div className="space-y-2.5">
              <a href={`mailto:${contactInfo.generalEmail}`}
                className="flex items-center gap-2 text-white/20 hover:text-[#00E5FF] text-xs transition-colors">
                <Mail className="w-3.5 h-3.5" />{contactInfo.generalEmail}
              </a>
              <a href={`mailto:${contactInfo.recruitmentEmail}`}
                className="flex items-center gap-2 text-white/20 hover:text-[#00E5FF] text-xs transition-colors">
                <Mail className="w-3.5 h-3.5" />{contactInfo.recruitmentEmail}
              </a>
              <a href={contactInfo.discord} target="_blank" rel="noopener noreferrer"
                className="flex items-center gap-2 text-white/20 hover:text-[#00E5FF] text-xs transition-colors">
                <MessageCircle className="w-3.5 h-3.5" />Join our Discord
              </a>
            </div>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="text-[11px] text-white/30 font-medium uppercase tracking-[0.15em] mb-4">Stay Updated</h3>
            <p className="text-white/20 text-xs mb-3">Get the latest news and announcements.</p>
            {subscribed ? (
              <div className="flex items-center gap-2 text-emerald-400 text-xs" data-testid="newsletter-success">
                <CheckCircle className="w-4 h-4" /> You're subscribed!
              </div>
            ) : (
              <form onSubmit={handleSubscribe} className="flex gap-2" data-testid="newsletter-form">
                <input type="email" value={email} onChange={e => setEmail(e.target.value)}
                  placeholder="your@email.com" required
                  data-testid="newsletter-email-input"
                  className="flex-1 bg-white/[0.03] border border-white/[0.08] rounded-lg px-3 py-2 text-white text-xs placeholder-white/20 focus:outline-none focus:ring-1 focus:ring-[#00E5FF]/30 min-w-0" />
                <button type="submit" disabled={loading}
                  data-testid="newsletter-submit-btn"
                  className="bg-[#00E5FF]/10 border border-[#00E5FF]/20 text-[#00E5FF] p-2 rounded-lg hover:bg-[#00E5FF]/20 transition-all disabled:opacity-50">
                  <Send className="w-3.5 h-3.5" />
                </button>
              </form>
            )}
          </div>
        </div>

        <div className="pt-6 border-t border-white/[0.04]">
          <p className="text-center text-white/10 text-[11px]">
            &copy; {new Date().getFullYear()} Starnight Holdings. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
